import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const CampaignBasics = ({ data, updateData, errors }) => {
  const genreOptions = [
    { value: 'pop', label: 'Pop' },
    { value: 'rock', label: 'Rock' },
    { value: 'hip-hop', label: 'Hip Hop' },
    { value: 'electronic', label: 'Electronic' },
    { value: 'jazz', label: 'Jazz' },
    { value: 'classical', label: 'Classical' },
    { value: 'indie', label: 'Indie' },
    { value: 'r&b', label: 'R&B' },
    { value: 'country', label: 'Country' },
    { value: 'other', label: 'Other' }
  ];

  const objectiveOptions = [
    { value: 'awareness', label: 'Brand Awareness', icon: 'Eye' },
    { value: 'engagement', label: 'Engagement', icon: 'Heart' },
    { value: 'streams', label: 'Increase Streams', icon: 'Music' },
    { value: 'followers', label: 'Gain Followers', icon: 'Users' },
    { value: 'viral', label: 'Go Viral', icon: 'TrendingUp' },
    { value: 'sales', label: 'Drive Sales', icon: 'ShoppingCart' }
  ];

  const toggleObjective = (value) => {
    const currentObjectives = data?.objectives || [];
    if (currentObjectives?.includes(value)) {
      updateData('objectives', currentObjectives?.filter(obj => obj !== value));
    } else {
      updateData('objectives', [...currentObjectives, value]);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">Campaign Basics</h2>
        <p className="text-muted-foreground">Let's start with the essential information about your campaign</p>
      </div>

      <div className="space-y-4">
        <Input
          label="Campaign Name"
          placeholder="e.g., Summer Single Launch 2026"
          value={data?.name || ''}
          onChange={(e) => updateData('name', e?.target?.value)}
          error={errors?.name}
          required
        />

        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">
            Description <span className="text-destructive">*</span>
          </label>
          <textarea
            className="flex min-h-[120px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder="Describe your campaign goals, target audience, and what makes this music special..."
            value={data?.description || ''}
            onChange={(e) => updateData('description', e?.target?.value)}
          />
          {errors?.description && (
            <p className="text-sm text-destructive mt-1">{errors?.description}</p>
          )}
        </div>

        <Input
          label="Music Track URL (Optional)"
          placeholder="https://spotify.com/track/..."
          value={data?.musicTrackUrl || ''}
          onChange={(e) => updateData('musicTrackUrl', e?.target?.value)}
          description="Link to your track on Spotify, Apple Music, or YouTube"
        />

        <Select
          label="Genre"
          placeholder="Select genre"
          options={genreOptions}
          value={data?.genre || ''}
          onChange={(value) => updateData('genre', value)}
          error={errors?.genre}
          required
        />

        <div>
          <label className="text-sm font-medium text-foreground mb-3 block">
            Campaign Objectives <span className="text-destructive">*</span>
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {objectiveOptions?.map((objective) => {
              const isSelected = data?.objectives?.includes(objective?.value);
              return (
                <button
                  key={objective?.value}
                  type="button"
                  onClick={() => toggleObjective(objective?.value)}
                  className={`flex items-center gap-3 p-4 rounded-lg border-2 transition-all ${
                    isSelected
                      ? 'border-primary bg-primary/10 text-primary' :'border-border bg-background text-foreground hover:border-primary/50'
                  }`}
                >
                  <Icon name={objective?.icon} size={20} />
                  <span className="text-sm font-medium">{objective?.label}</span>
                  {isSelected && (
                    <Icon name="Check" size={16} className="ml-auto" />
                  )}
                </button>
              );
            })}
          </div>
          {errors?.objectives && (
            <p className="text-sm text-destructive mt-2">{errors?.objectives}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignBasics;
